import getSymbolFromCurrency from 'currency-symbol-map';
import isEmpty from 'lodash/isEmpty';
import { ReactElement } from 'react';
import { getCompressedImage } from 'utils/images';

export const getObjProperty = (obj?: Record<string, unknown>, prop?: string, defVal?: unknown) => {
  const val =
    prop &&
    // eslint-disable-next-line
    prop.split('.').reduce((m: any, i: string) => (m && typeof m === 'object' ? m[i] : null), obj);
  return val !== undefined && val != null ? val : defVal;
};

export const getObjContentList = (obj: Record<string, unknown>, path: string) => {
  const contentList = getObjProperty(obj, path);

  if (contentList) return createContentList(contentList);
};

export const getObjPropertyMap = (obj: Record<string, unknown>, props: Record<string, string>) => {
  return Object.keys(props).reduce<Record<string, unknown>>((result, key) => {
    const value = getObjProperty(obj, props[key]);
    if (value) {
      result[key] = value;
    }
    return result;
  }, {});
};

export const createContentList = (array?: Array<Record<string, unknown>>) => {
  return (
    array &&
    array.map((item: Record<string, unknown>) => ({
      item: getObjProperty(item, 'data'),
      label: getObjProperty(item, 'label')
    }))
  );
};

export const removeEmpty = (object: Record<string, unknown>) => {
  if (object == undefined) return;

  return Object.entries(object).reduce(
    (acc, [key, value]) => (value ? { [key]: value, ...acc } : acc),
    {}
  );
};

export const getGalleryItems = (media?: string[], size?: { width: number; quality: number }) => {
  return media
    ? media
        ?.filter((mediaSrc) => !!mediaSrc)
        .map((mediaSrc: string) => {
          return {
            original: getCompressedImage(mediaSrc, size)
          };
        })
    : [];
};

export function sortObject(
  obj: Record<string, unknown>,
  sortFunc?: (a: string, b: string) => number
) {
  return Object.keys(obj)
    .sort(sortFunc)
    .reduce(function (result: Record<string, unknown>, key) {
      result[key] = obj[key];
      return result;
    }, {});
}

export function isNotEmpty(obj?: Record<string, unknown> | Array<unknown>) {
  return obj && !isEmpty(obj);
}

export function isElementNotEmpty(element?: ReactElement): boolean | undefined {
  return !!element && isNotEmpty(element?.props?.children?.filter((child) => !!child));
}

export const getNumeric = (value?: unknown): number | undefined => {
  const numValue = Number(value);
  return isNumeric(numValue) ? numValue : undefined;
};

export const isNumeric = (value?: unknown): boolean => {
  return value !== undefined && !isNaN(Number(value));
};

export const isString = (value?: unknown) => {
  return value !== undefined && (typeof value === 'string' || value instanceof String);
};

export const nullToEmptyStr = (value?: string | null | unknown) => {
  return !!value ? String(value) : '';
};

export const toBoolean = (value?: unknown) => {
  if (!value) return false;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return false;
};

export const getCurrencySymbol = (currency?: string) => {
  return currency ? getSymbolFromCurrency(currency) : '$';
};

export const pastTense = (verb?: string) => {
  if (!verb) return verb;
  return (
    verb
      .replace(/([^aeiouy])y$/, '$1i')
      .replace(/([^aeiouy][aeiou])([^aeiouy])$/, '$1$2$2')
      .replace(/e$/, '') + 'ed'
  );
};

export const capitalize = (str?: string) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const asParameterName = (str?: string) => {
  if (!str) return str;
  return str.replace(/\W/gi, '_').toLowerCase();
};
